import { useState } from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import MenuItem from '@mui/material/MenuItem';
import PhoneInputForm from 'uI/PhoneInputForm/PhoneInputForm';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import DropZonefile from 'uI/DropZoneFile/DropZoneFile';

import classes from './UserInputs.module.css';

const UserInputs = props => {
  const [email, setEmail] = useState(props.userInfo.email);
  const [phone, setPhone] = useState(props.userInfo.phone);
  const [lada, setLada] = useState(props.userInfo.lada);
  const [cfdiUser, setCfdiUser] = useState(props.userInfo.cfdiUse);
  const [automatic, setAutomatic] = useState(
    props.userInfo.isAutomatic
  );
  const [file, setFile] = useState('');

  const phoneHandler = (lada, phone) => {
    setLada(`+${lada}`);
    setPhone(phone);
  };

  const changeEmailHandler = event => {
    setEmail(event.target.value);
  };

  const cfiChangeHandler = event => {
    setCfdiUser(event.target.value);
  };

  const handleBill = () => {
    setAutomatic(!automatic);
  };

  const fileHandler = file => {
    setFile(file);
  };

  const closeHandler = () => {
    props.close();
    setFile('');
  };

  const setUserBillingHandler = () => {
    props.setUserBilling(
      cfdiUser,
      email,
      lada,
      phone,
      automatic,
      file
    );
  };

  return (
    <>
      <DialogTitle className={classes.title}>
        Datos de facturación
      </DialogTitle>
      <DialogContent className={classes.contentContainer}>
        <div className={classes.phonecontainer}>
          <PhoneInputForm
            phoneHandler={phoneHandler}
            phone={`${lada}${phone}`}
          />
        </div>
        <TextField
          label="Correo electrónico para envío de factura *"
          className={classes.textField}
          placeholder="Correo electrónico para envío de factura *"
          value={email}
          variant="outlined"
          onChange={changeEmailHandler}
        />
        <TextField
          label="Uso (CFDI) *"
          variant="standard"
          onChange={cfiChangeHandler}
          select
          className={classes.textFieldCfdi}
          InputLabelProps={{
            shrink: true
          }}
          value={cfdiUser}
        >
          {props.cfdi.map(option => {
            return (
              <MenuItem
                key={option.clave}
                value={option.clave}
                className={classes.optionItem}
              >
                {option.description}
              </MenuItem>
            );
          })}
        </TextField>
        <p className={classes.text}>
          Constancia de Situación Fiscal*
        </p>
        <DropZonefile archiveHandler={fileHandler} />
        <FormControlLabel
          control={
            <Checkbox
              checked={automatic}
              onChange={handleBill}
              value="bill"
              color="primary"
            />
          }
          label={
            <p className={classes.billText}>
              Solicitar factura automáticamente para cada pago
              realizado
            </p>
          }
        />
        <p className={classes.warning}>* Datos obligatorios</p>
      </DialogContent>
      <div className={classes.btnsContainer}>
        <Button onClick={closeHandler} className={classes.cancelBtn}>
          Cancelar
        </Button>
        <Button
          disabled={!(email && lada && phone && cfdiUser)}
          onClick={setUserBillingHandler}
          className={classes.acceptBtn}
        >
          Guardar
        </Button>
      </div>
    </>
  );
};

UserInputs.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userInfo: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  cfdi: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  close: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  setUserBilling: PropTypes.func
};

export default UserInputs;
